import React, { useState } from 'react';
import AreaCodeInput from "../../../Components/form_elements/areaCodeInput";
import PhoneNumberInput from "../../../Components/form_elements/phoneNumberInput";
import { Col, Row } from 'react-bootstrap';
import { useFormContext } from 'clayco-component-library/lib';

const PhoneControl = ({international, onChange, areaCodeInitial, numberInitial}) => {
    const {register} = useFormContext();
    const [isInt, setInternational] = useState(international);

    function handleIntToggle(val) {
        setInternational(val);
    }

    return(
        <>
        {/* <Row>
            <Col className='col-12 col-lg-2'>
                <div className="form-check form-switch mt-2 mb-3">
                    <input {...register('international')} className="form-check-input" 
                        type="checkbox" role="switch" id="flexSwitchCheckDefault" 
                        onChange={(e)=> handleIntToggle(e.currentTarget.checked)}
                        defaultChecked={isInt}/>
                    <label className="form-check-label" for="flexSwitchCheckDefault">International</label>
                </div>
            </Col>
        </Row> */}
        <Row>
        <Col className="col-12 col-lg-4">
                <AreaCodeInput
                    key="areaCodeInput"
                    label={isInt ? "Country Code":"Area Code"}
                    required={true}
                    international={isInt}
                    showTooltip={false}
                    name="areaCode"
                    initialValue={areaCodeInitial}
                    onChange={onChange}
                    />
                </Col>
                <Col className="col-12 col-lg-4">
                    <PhoneNumberInput
                        label="Phone Number"
                        required={true}
                        showTooltip={false}
                        international={isInt}
                        name="phoneNumber"
                        type="tel"
                        initialValue={numberInitial}
                        onChange={onChange}
                    />
                </Col>
        </Row>
        </>
    )
}

export default PhoneControl